export default "__VITE_ASSET__BuXkJtTo__"